<template>
    <div class="container-fluid">
        <h3>
            {{ product.title }} | Files
        </h3>
        <blockquote class="mb-3">
            <a :href="`/admin/product/${product_id}/edit`">Go back to this product</a>
            <div v-html="`Title: ${product.title}`" />
            <div v-if="product.description" v-html="`Description: ${product.description}`" />
        </blockquote>
        <small>
            In this section you can manage product files. You can preview, delete files or upload new files with multiple uploader. Just click to add files and choose files that you want to upload
        </small>
        <table class="table table-stripped table-hover table-bordered">
            <thead>
            <tr>
                <th>Title</th>
                <th>Url</th>
                <th>Link Resource Type</th>
                <th>Save Date</th>
                <th>Is Active</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="resource in resources" v-if="resources.length>0">
                <td v-text="resource.title"></td>
                <td>
                    <a :href="resource.url" rel="nofollow" target="_blank" v-text="resource.title"></a>
                </td>
                <td v-text="get(resource, 'type.name')"></td>
                <td v-text="resource.updated_at"></td>
                <td v-text="resource.is_active? 'Yes': 'No'"></td>
                <td>
                    <button class="btn btn-primary" title="edit" type="button" @click="loadResource(resource)">
                        <i class="icon-edit" />
                    </button>
                    <button class="btn btn-danger" title="Delete without confirmation" type="button" @click="deleteResource(resource)">
                        <i class="icon-trash" />
                    </button>
                </td>
            </tr>
            <tr v-if="resources.length === 0">
                <td colspan="100">
                    No resources at this time
                </td>
            </tr>
            </tbody>
        </table>
        <hr>
        <h3>Upload new resources:</h3>
        <form @submit.prevent="handleFormSubmit" v-if="this.edit == 0">
            <basic-input v-model="form.title" label="Title" name="title" />
            <basic-input v-model="form.description" label="Description" name="description" />
            <label>Type</label><br>
            <select v-model="form.resource_type_id" name="resource_type_id">
                <option :value="type.id" v-for="type in this.types">{{type.name}}</option>
            </select>
            <basic-input ref="uploadFile" label="Add Files" name="file" type="file" @change="handleTrackFile" />
            <basic-input v-model="form.is_active" label="Is Active" name="is_active" type="checkbox" />
            <button class="btn btn-primary" type="submit">Submit</button>
        </form>
        <form @submit.prevent="update" v-if="this.edit > 0">
            <basic-input v-model="formUpdate.title" label="Title" name="title" />
            <basic-input v-model="formUpdate.description" label="Description" name="description" />
            <label>Type</label><br>
            <select v-model="formUpdate.resource_type_id" name="resource_type_id">
                <option :value="type.id" v-for="type in this.types">{{type.name}}</option>
            </select>
            <basic-input v-model="formUpdate.is_active" label="Is Active" name="is_active" type="checkbox" />
            <button class="btn btn-primary" type="submit">Update</button>
        </form>
    </div>
</template>
<script>
import { get } from 'lodash';

export default {
    props: ['product_id'],
    name: 'ProductResource',
    data () {
        return {
            product: {},
            resources: [],
            types: {},
            edit: 0,
            form: {
                title: '',
                description: '',
                resource_type_id: 0,
                is_active: true,
                file: {},
            },
            formUpdate: {
                title: '',
                description: '',
                resource_type_id: 0,
                is_active: true,
            },
            sendingForm: null,
            sendingForm1: null,
        };
    },
    methods: {
        get (arr, key, defaultValue = '') {
            return get(arr, key, defaultValue);
        },
        handleTrackFile ({ target }) {
            const { files = null } = target;
            if (!files || files.length === 0) {
                return true;
            }

            this.sendingForm = new FormData();
            this.sendingForm1 = new FormData();
            this.sendingForm.append('file', files[0], files[0].name);
        },
        async handleFormSubmit () {
            const { title, description, is_active, resource_type_id } = this.form;
            this.sendingForm.append('title', title);
            this.sendingForm.append('description', description);
            this.sendingForm.append('is_active', is_active);
            this.sendingForm.append('resource_type_id', resource_type_id);
            this.sendingForm.append('edit', this.edit);

            try {
                if(this.edit > 0){
                    await axios.post(`/api/product/resource/put`,this.sendingForm);
                    this.edit = 0;
                }
                else {
                    await axios.post(`/api/product/${this.product_id}/resource`, this.sendingForm);
                }
                await this.load();

                this.$refs.uploadFile.value = null;
                this.sendingForm = null;
                this.form = {
                    title: '',
                    resource_type_id: '',
                    is_active: true,
                    file: {},
                };
            } catch (e) {
                console.log('upload error', { e });
            }
        },
        async update(){

            const { title, description, is_active, resource_type_id } = this.formUpdate;
            // this.sendingForm.append('title', title);
            // this.sendingForm1.append('description', description);
            // this.sendingForm1.append('is_active', is_active);
            // this.sendingForm1.append('resource_type_id', resource_type_id);
            // this.sendingForm1.append('edit', this.edit);
            console.log(title);
            console.log(description);
            console.log(is_active);
            console.log(resource_type_id);
            try {
                await axios.post(`/api/product/resource/put`,this.formUpdate);
                alert(title + " is updated");
                this.edit = 0;
                this.load();
            } catch (e) {
                console.log('upload error', { e });
            }
        },
        async deleteResource ({ uuid }) {
            await axios.delete(`/api/product/${this.product_id}/resource/${uuid}`);
            await this.load();
        },
        async loadResource(resource){
            this.formUpdate = Object.assign({}, resource);
            this.edit = resource.id;
        },
        async load () {
            const { data } = await axios.get(`/api/product/${this.product_id}`);
            const { images = [], resources = [], ...product } = data || {};

            this.product = product;
            this.resources = resources;
        },
        async loadTypes () {
            const axios = require('axios').default;

            axios.get('/api/product/resourceTypes')
                .then(resp => {
                    this.types = resp.data;
                })
        },
    },
    async mounted () {
        await this.load();
        await this.loadTypes();
    },
};
</script>
